import {createContext, useContext} from "react";
import {SmsAuthController} from "../../controller/sms-auth-controller";
import {GroupJoinController} from "../../controller/group-join-controller";

export const SmsAuthControllerContext = createContext<SmsAuthController|undefined>(undefined);
export const useSmsAuthControllerContext = () => useContext(SmsAuthControllerContext);

export const GroupJoinControllerContext = createContext<GroupJoinController|undefined>(undefined);
export const useGroupJoinControllerContext = () => useContext(GroupJoinControllerContext);